import { render } from "./ContentComponent.vue?vue&type=template&id=b02cd55e&scoped=true"
import script from "./ContentComponent.vue?vue&type=script&lang=js"
export * from "./ContentComponent.vue?vue&type=script&lang=js"

import "./ContentComponent.vue?vue&type=style&index=0&id=b02cd55e&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b02cd55e"]])

export default __exports__